<nav aria-labelledby="acciones-de-cabecera">
  <p
    class="sr-only"
    id="acciones-de-cabecera">
    Menú de acciones
  </p>
  <ul class="flex flex-wrap flex-column-reverse lg:flex-row-reverse gap-sm lg:items-center lg:ml-auto lg:pl-base">
    <li>
      <desy-button
        [text]="'Guardar'"
        [classes]="'c-button--primary c-button--sm'"
        [routerLink]="''"></desy-button>
    </li>
    <li>
      <desy-button
        [text]="'Salir'"
        [classes]="'c-button--sm'"
        [routerLink]="'/'"></desy-button>
    </li>
  </ul>
</nav>
